module.exports = __webpack_public_path__ + "img/img12.b05bceaa.png";